module.exports = "/packs/007-ed2217a6526c2369ea01bcc0d5094bfe.jpg";